import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { ApiTypes } from 'shared/data/webApp/v2';

export const getModifiedRequest = <Request extends selectors.types.ExpandedRequest>(
    request: Request,
    snapshot: ApiTypes['V2RequestsRequestAnswerCamelCased']
): Request => {
    let details: Request['details'] = request.details;

    switch (request.integrationCode) {
        case domain.IntegrationCode.XeroBill: {
            if (!snapshot.xeroInvoiceDetails) break;

            details = domain.schemas.request.mapXeroBillDetailsV2({
                ...snapshot.xeroInvoiceDetails,
                invoiceId: request.id,
            });

            break;
        }

        case domain.IntegrationCode.XeroPo: {
            if (!snapshot.xeroPurchaseOrderDetails) break;

            details = domain.schemas.request.mapXeroPurchaseOrderV2(
                snapshot.xeroPurchaseOrderDetails,
                snapshot.emailToContact
            );

            break;
        }

        case domain.IntegrationCode.XeroInvoice: {
            if (!snapshot.xeroSalesInvoiceDetails) break;

            details = domain.schemas.request.mapXeroInvoiceV2(snapshot.xeroSalesInvoiceDetails);

            break;
        }

        case domain.IntegrationCode.XeroCreditNotesPayable: {
            if (!snapshot.xeroCreditNoteDetails) break;

            details = domain.schemas.request.mapCreditNoteV2(
                snapshot.xeroCreditNoteDetails,
                domain.IntegrationCode.XeroCreditNotesPayable
            );

            break;
        }

        case domain.IntegrationCode.XeroCreditNotesReceivable: {
            if (!snapshot.xeroCreditNoteDetails) break;

            details = domain.schemas.request.mapCreditNoteV2(
                snapshot.xeroCreditNoteDetails,
                domain.IntegrationCode.XeroCreditNotesReceivable
            );

            break;
        }

        case domain.IntegrationCode.XeroBillBatchPayment: {
            if (!snapshot.xeroBillBatchPaymentDetails) break;

            details = domain.schemas.request.mapXeroBillBatchPaymentDetailsV2(snapshot.xeroBillBatchPaymentDetails);

            break;
        }

        case domain.IntegrationCode.XeroContact: {
            if (!snapshot.xeroContactDetails) break;

            details = domain.schemas.request.mapXeroContactDetails(snapshot.xeroContactDetails);

            break;
        }

        case domain.IntegrationCode.XeroAirwallexBatchPayment: {
            if (!snapshot.airwallexXeroBatchPaymentDetails) break;

            details = domain.schemas.request.mapAirwallexBatchPaymentDetails(snapshot.airwallexXeroBatchPaymentDetails);

            break;
        }

        case domain.IntegrationCode.XeroQuote: {
            if (!snapshot.xeroQuoteDetails) break;

            details = domain.schemas.request.mapXeroQuoteDetailsV2(snapshot.xeroQuoteDetails);

            break;
        }

        case domain.IntegrationCode.XeroManualJournal: {
            if (!snapshot.xeroManualJournalDetails) break;

            details = domain.schemas.request.mapXeroManualJournalDetailsV2(snapshot.xeroManualJournalDetails);

            break;
        }

        case domain.IntegrationCode.QBooksPo: {
            if (!snapshot.qBooksPurchaseOrderDetails) break;

            details = domain.schemas.request.mapQboPurchaseOrderV2(
                {
                    ...snapshot.qBooksPurchaseOrderDetails,
                    departmentTerminology: request.details.departmentTerminology ?? undefined,
                },
                snapshot.emailToContact
            );

            break;
        }

        case domain.IntegrationCode.QBooksBill: {
            if (!snapshot.qBooksBillInvoiceDetails) break;

            details = domain.schemas.request.mapQboBillV2({
                ...snapshot.qBooksBillInvoiceDetails,
                departmentTerminology: request.details.departmentTerminology ?? undefined,
            });

            break;
        }

        case domain.IntegrationCode.QBooksExpense: {
            if (!snapshot.qBooksExpenseDetails) break;

            details = domain.schemas.request.mapQboExpenseV2({
                ...snapshot.qBooksExpenseDetails,
                departmentTerminology: request.details.departmentTerminology ?? undefined,
            });

            break;
        }

        default:
            break;
    }

    return {
        ...request,
        flags: { ...request.flags, isActualVersion: false },
        amount: snapshot.amount,
        currency: snapshot.currency,
        displayName: snapshot.friendlyName,
        createdDate: snapshot.createdAt,
        modifiedDate: snapshot.modifiedAt,
        attachments: (snapshot.attachments || []).map(domain.schemas.request.mapAttachment),
        requestNote: {
            value: snapshot.requestNote || '',
            errorMessages: null,
        },
        version: snapshot.version,
        details,
        exchangeRate: snapshot.exchangeRate,
        exchangeRateSource: snapshot.exchangeRateSource,
        exchangeRateDate: null,
    };
};
